module.exports = __webpack_public_path__ + "img/091-ossetia.8d82a9bd.svg";